import React, { useEffect, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import styled from "styled-components";
import { CalendarToday } from "@mui/icons-material";
import DatePicker from "react-datepicker";

import { useDate } from "../../../../utility/useDate";
import { PortalDatePickerProps } from "./PortalDateTime"

export default function PortalDatePicker(props: PortalDatePickerProps) {

    const { toFormattedFullDateString } = useDate();

    const Wrapper = styled.div`
        & .react-datepicker-popper {
            z-index: 2;
        }
    `;

    const displayStyle = props.readOnly ? 'none' : 'inline-block';

    const datePickerProps = { ...props };
    const [dpValue, setDpValue] = useState<Date>();

    useEffect(() => {
        if (datePickerProps.minDate && datePickerProps.initializeFilled && dpValue) {
            datePickerProps.onChange(datePickerProps.minDate, undefined);
        }
    }, []);

    if (!dpValue && datePickerProps.minDate && datePickerProps.defaultValue) {
        setDpValue(datePickerProps.minDate);
    }

    datePickerProps.selected = dpValue && datePickerProps.minDate && dpValue > datePickerProps.minDate ? dpValue : undefined;

    // force the state-stored date to keep up with any provided minDate
    if (datePickerProps.minDate && dpValue && datePickerProps.minDate > dpValue) {
        setDpValue(datePickerProps.minDate);
    }

    // update the selected in the picker to keep up with any provided minDate
    if (datePickerProps.minDate && dpValue) {
        datePickerProps.selected = dpValue > datePickerProps.minDate ? dpValue : datePickerProps.minDate;
    }

    // initialize a starting date value if the prop is passed in
    if (datePickerProps.minDate && props.initializeFilled && !dpValue) {
        setDpValue(datePickerProps.minDate);
    }

    const customInput = <TextField
        size="small"
        variant="standard"
        label={props.label}
        style={{ display: displayStyle }}
        InputProps={{
            endAdornment: <InputAdornment position="end"><CalendarToday /></InputAdornment>,
            value: toFormattedFullDateString(dpValue),
            placeholder: "dd/mm/yy"
        }}
        slotProps={{
            htmlInput: {
                "data-testid": props.testId
            }
        }} />;

    return (
        <Wrapper>
            {props && <DatePicker
                customInput={customInput}
                {...datePickerProps}
                onChange={(val) => {
                    if (val) {
                        setDpValue(val);
                        datePickerProps.onChange(val, undefined);
                    }
                }} />}
        </Wrapper>
    );
}